import { CardContent, Typography, Box } from "@mui/material";
import { TcuAppointmentCardBodyProps } from "./TcuAppointmentCardBody.types";
import { sxStyles } from "./TcuAppointmentCardBody.styles";
import {
  formatDate,
  formatOptions,
} from "lib/util/DateTimeUtil/formatDate/formatDate";
import { formatDateToISO } from "lib/util/DateTimeUtil/formatDateToISO/formatDateToISO";
import Tags from "lib/components/tags/Tags";

const TcuAppointmentCardBody = ({
  institution,
  datetime,
  serviceDisplayName,
  apptStatusTag,
}: TcuAppointmentCardBodyProps) => {
  const classes = sxStyles();
  /* Test build */
  return (
    <CardContent sx={classes.cardDetailWrapper} aria-label="cardDetailWrapper">
      <Box sx={classes.cardDetails}>
        {institution && (
          <Box sx={classes.cardInstitutionAndTags}>
            <Typography sx={classes.cardTitle}>{institution}</Typography>
            {apptStatusTag && apptStatusTag !== "" && (
              <Box sx={classes.tagWrapper}>
                <Tags label={apptStatusTag} colorChoice="green" />
              </Box>
            )}
          </Box>
        )}
        <Typography sx={classes.cardTime}>
          {datetime
            ? formatDate(
                formatDateToISO(datetime),
                formatOptions.timeWithPeriod,
              )
            : null}
        </Typography>
        {serviceDisplayName && (
          <Typography sx={classes.cardSubtitle} component="h5">
            {serviceDisplayName}
          </Typography>
        )}
      </Box>
    </CardContent>
  );
};

export default TcuAppointmentCardBody;
